import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Stack,
  Select,
  MenuItem,
  TextField,
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  FormControlLabel
} from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import jaLocale from 'date-fns/locale/ja';
import { LoadingButton, DesktopDatePicker } from '@mui/lab';
import moment from 'moment';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: { xs: 'auto', sm: 96 },
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

// ----------------------------------------------------------------------

ListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  onDelete: PropTypes.func
};

export default function ListToolbar({
  sales_type,
  partner_code,
  device_code,
  dtS,
  dtE,
  numSelected,
  filterName,
  isMobile,
  onFilterName,
  onDelete,
  onChangeType,
  onChangeStatus,
  onChangePartnerCode,
  onChangeDeviceCode,
  onChangeDateS = null,
  onChangeDateE = null
}) {
  const { SystemLib } = window;
  const [status, setStatus] = useState(-1);
  const statuses = [
    { code: 'sale', name: '未承認' },
    { code: 'approved', name: '承認済' }
  ];
  const [type, setType] = useState(sales_type);
  const types = [
    { code: 0, name: 'marche' },
    { code: 10000, name: 'はなまる' },
    { code: 20000, name: '味仙' }
  ];
  const [partnerCode, setPartnerCode] = useState(partner_code);
  const [partners, setPartners] = useState([]);
  const [deviceCode, setDeviceCode] = useState(device_code);
  const [devices, setDevices] = useState([]);
  const [dto_s, setDtoS] = useState(moment(dtS).toDate());
  const [dto_e, setDtoE] = useState(moment(dtE).toDate());
  const [dt_s, setDtS] = useState(dtS);
  const [dt_e, setDtE] = useState(dtE);
  // alert(`${dtS} : ${dtE}`);
  const [back, setBack] = useState('back');

  useEffect(() => {
    getPartners();
  }, []);

  const getPartners = async () => {
    const { data } = await SystemLib.api('layin/partners', {}, 'post');
    if (data.result) {
      setPartners(data.data);
    }
  };

  useEffect(() => {
    getDevices();
  }, []);

  const getDevices = async () => {
    const { data } = await SystemLib.api('sale/devices', {}, 'post');
    if (data.result) {
      setDevices(data.data);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={jaLocale}>
      <RootStyle
        sx={{
          ...(numSelected > 0 && {
            color: 'primary.main',
            bgcolor: 'primary.lighter'
          })
        }}
      >
        {numSelected > 0 ? (
          <Typography component="div" variant="subtitle1">
            {numSelected} 件 選択中
          </Typography>
        ) : (
          <Stack
            direction="row"
            flexWrap={{ xs: 'wrap', sm: 'nowrap' }}
            alignItems="center"
            justifyContent="flex-start"
            gap={2}
          >
            {/* <Select
              labelId="select_label_status"
              id="select_status"
              value={status}
              onChange={(e) => {
                setStatus(e.target.value);
                onChangeStatus(e.target.value);
              }}
            >
              <MenuItem value={-1}>状況 選択...</MenuItem>
              {statuses.map((v) => (
                <MenuItem key={v.code} value={v.code}>
                  {v.name}
                </MenuItem>
              ))}
            </Select> */}
            <Select
              labelId="select_label_type"
              id="select_type"
              value={type}
              onChange={(e) => {
                setType(e.target.value);
                onChangeType(e.target.value);
              }}
            >
              <MenuItem value={-1}>種別 選択...</MenuItem>
              {types.map((v) => (
                <MenuItem key={v.code} value={v.code}>
                  {v.name}
                </MenuItem>
              ))}
            </Select>
            <Select
              labelId="select_label_partner"
              id="select_partner"
              value={partnerCode}
              onChange={(e) => {
                setPartnerCode(e.target.value);
                onChangePartnerCode(e.target.value);
              }}
            >
              <MenuItem value={-1}>パートナー選択...</MenuItem>
              {partners.map((v) => (
                <MenuItem key={v.code} value={v.code}>
                  {v.name}
                </MenuItem>
              ))}
            </Select>
            <Select
              labelId="select_label_device"
              id="select_device"
              value={deviceCode}
              onChange={(e) => {
                setDeviceCode(e.target.value);
                onChangeDeviceCode(e.target.value);
              }}
            >
              <MenuItem value={-1}>デバイス選択...</MenuItem>
              {devices.map((v) => (
                <MenuItem key={v.code} value={v.code}>
                  {v.name}
                </MenuItem>
              ))}
            </Select>
            <DesktopDatePicker
              id="dt_s"
              label="開始日"
              inputFormat="yyyy-MM-dd"
              value={dto_s}
              onChange={(v) => {
                setDtoS(moment(v).toDate());
                if (v === '' || v === null) {
                  setDtS(-1);
                  onChangeDateS(-1);
                } else {
                  setDtS(moment(v).format('YYYY-MM-DD'));
                  onChangeDateS(moment(v).format('YYYY-MM-DD'));
                }
              }}
              renderInput={(params) => (
                <TextField
                  disablePast
                  {...params}
                  error={false}
                  helperText={null}
                  sx={{ width: { xs: '160px', sm: 'auto' } }}
                />
              )}
            />
            <DesktopDatePicker
              id="dt_e"
              label="終了日"
              inputFormat="yyyy-MM-dd"
              value={dto_e}
              onChange={(v) => {
                setDtoE(moment(v).toDate());
                if (v === '' || v === null) {
                  setDtE(-1);
                  onChangeDateE(-1);
                } else {
                  setDtE(moment(v).format('YYYY-MM-DD'));
                  onChangeDateE(moment(v).format('YYYY-MM-DD'));
                }
              }}
              renderInput={(params) => (
                <TextField
                  disablePast
                  {...params}
                  error={false}
                  helperText={null}
                  sx={{ width: { xs: '160px', sm: 'auto' } }}
                />
              )}
            />
            <SearchStyle
              value={filterName}
              onChange={onFilterName}
              placeholder="商品検索..."
              startAdornment={
                <InputAdornment position="start">
                  <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                </InputAdornment>
              }
            />
          </Stack>
        )}

        {numSelected > 0 ? (
          <Stack direction="row" spacing={2}>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              sx={{ width: '14em', backgroundColor: '#ffffff', padding: 0.5, borderRadius: 1 }}
            >
              <Typography variant="body2">商品を倉庫に</Typography>
              <FormControl variant="outlined" size="small">
                <Select
                  labelId="backMode-label"
                  id="backMode"
                  value={back}
                  label="モード"
                  onChange={(e) => setBack(e.target.value)}
                >
                  <MenuItem value="back">戻す</MenuItem>
                  <MenuItem value="none">戻さない</MenuItem>
                </Select>
              </FormControl>
            </Stack>
            <Tooltip title="選択削除">
              <Button
                size="small"
                type="button"
                variant="contained"
                disableElevation
                onClick={() => {
                  onDelete(back);
                }}
              >
                削除する
              </Button>
            </Tooltip>
          </Stack>
        ) : null}
      </RootStyle>
    </LocalizationProvider>
  );
}
